import { Grid, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { Link, LoadingButton } from 'components';
import { useAuth } from 'context/AuthContext';
import { useNotifications } from 'context/NotificationsContext';
import { Field, Formik } from 'formik';
import { TextField } from 'formik-material-ui';
import { useForgotPasswordMutation } from 'graphql/generated';
import { useTranslation } from 'react-i18next';
import React, { useState } from 'react';
import { useStyles } from './forgot-password.style';
import { validationSchema } from './validationSchema';

type ForgotPasswordFormProps = {
    pageUsage?: boolean;
};

export const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({ pageUsage = false }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { selectTab } = useAuth();
    const { notify } = useNotifications();
    const [success, setSuccess] = useState(false);

    const [resetPassword, { loading }] = useForgotPasswordMutation({
        onCompleted() {
            setSuccess(true);
        },
        onError(error) {
            notify({
                type: 'error',
                message: t(`error:${error.message}`) || `${t('defaultErrorMessage')}`,
            });
        },
    });

    const onSubmit = ({ email }): void => {
        resetPassword({ variables: { input: { email } } });
    };

    return (
        <Formik initialValues={{ email: '' }} validationSchema={validationSchema} onSubmit={onSubmit}>
            {({ handleSubmit }): React.ReactNode => (
                <form onSubmit={handleSubmit} className={classes.form}>
                    {success && (
                        <Grid item xs={12}>
                            <Alert style={{ width: '100%' }} severity="info">
                                {t('forgotPassword:info')}
                            </Alert>
                        </Grid>
                    )}
                    <Field
                        component={TextField}
                        fullWidth
                        variant="outlined"
                        name="email"
                        label={t('forgotPassword:email')}
                        type="email"
                        margin="normal"
                        autoComplete="off"
                        autoFocus
                        disabled={loading}
                        inputProps={{
                            autoCapitalize: 'none',
                        }}
                    />
                    <Link
                        link
                        to={pageUsage ? '/sign-in' : '#'}
                        onClick={() => {
                            if (!pageUsage) {
                                selectTab(0);
                            }
                        }}
                    >
                        <Typography variant="h6">{t('forgotPassword:login')}</Typography>
                    </Link>
                    <LoadingButton
                        color="primary"
                        variant="contained"
                        className={classes.submit}
                        fullWidth
                        type="submit"
                        loading={loading}
                        loadingText={t('forgotPassword:sending')}
                        text={t('forgotPassword:send')}
                    />
                </form>
            )}
        </Formik>
    );
};
